<div class="form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-cog table-icon-header"
                       style="width: 2em"></i>{{ formTitle }}
                </TD>

                <TD align="left" style="min-width: 400px;">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                           class="qs_filter-field"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 10px; text-align: center;"></TD>
                <TD style="width: 250px"> 
                <label *ngIf="!enableEmail" style="    color: grey;font-size: medium;font-weight: 400;">Email is currently disabled</label>                   
                </TD>
                <TD class="table-pagination-cell" align="right">{{ pagination }} Record(s) ...</TD>
            </TR>
        </table>
    </div>


	<div class="main-client-area">
        <!--------------------------->
        <!-- RECORDS TABLE         -->
        <!--------------------------->
        <div class="table-container mat-elevation-z1"
	          (keydown)="tableKeyDown($event)" tabindex="-1">
	        <table mat-table [dataSource]="dataSource" matSort style="width:100%;"
	               (matSortChange)="onSortChange($event)">
	            <!-- Application Event Id -->
	            <ng-container matColumnDef="id">
	                <th mat-header-cell *matHeaderCellDef class="table-row" [hidden]="true"
	                    style="background-color: white; z-index:99999; width: 45px;">Id
	                </th>
	                <td mat-cell style="width:45px !important;" class="table-row" [hidden]="true"
	                    *matCellDef="let element">{{ element.id }}
	                </td>
	            </ng-container>
	            <!-- Application Event Description -->
	            <ng-container matColumnDef="eventDescription">
	                <th mat-header-cell *matHeaderCellDef class="table-row"
	                    style="background-color: white; z-index:99999; width: 220px;padding-left: 5px;">Event
	                </th>
	                <td mat-cell style="width:20%;padding-left: 5px;" class="table-row"
	                    *matCellDef="let element">{{ element.eventDescription }}
	                </td>
	            </ng-container>
	            <!-- Message definition id -->
	            <ng-container matColumnDef="messageId">
	                <th mat-header-cell *matHeaderCellDef [hidden]="true"
	                    style="background-color: white; z-index:99999; width: 25px;">
	                </th>
	                <td mat-cell style="width:25px;" [hidden]="true"
	                    *matCellDef="let element">{{ element.messageId }}
	                </td>
	            </ng-container>
	            <!-- Message Description -->
	            <ng-container matColumnDef="messageDescription">
	                <th mat-header-cell *matHeaderCellDef class="table-row"
	                    style="background-color: white; z-index:99999; width: 220px;">Message
	                </th>
	
	                <td mat-cell style="width:30%;" class="table-row" *matCellDef="let element">
	                    <dw-dropdown *ngIf="(selectedRecord?.id == element.id) "
	                                 [ngStyle]="{'color':returnMessageColor(selectedRecord?.messageId)}"
	                                 [disabled]="editMode || !visibleModify"
	                                 [selectedItem]="element.messageId"
	                                 [dataSource]="messageDropDownItems"
	                                 [controlWidth]="'calc(100% - 75px)'"
	                                 (itemSelected)="element.messageId = $event; onMessageChange(element)">
	                    </dw-dropdown>
						
	                    <span *ngIf="selectedRecord?.id !== element.id" style="display: inline-flex; width: calc(100% - 65px);">
	                    	<span [ngStyle]="{'color':returnMessageColor(element.messageId, element.messageDescription)}" style="display: block; height: 40px; align-content: center;">{{element.messageDescription}}</span>
	                    </span>
	                    <span>
		                    <button mat-icon-button color="primary" [disabled]="(element.messageId === 0) || !visibleModify"
                                    style="text-align: right;"
                                    (click)="doDialogMessageBody()">
						        <mat-icon>edit</mat-icon>
						    </button>
					    </span>
	                </td>
	            </ng-container>
	            <!-- Message subject -->
	            <ng-container matColumnDef="subject">
	                <th mat-header-cell *matHeaderCellDef 
	                    style="background-color: white; z-index:99999; width: 220px;">Subject
	                </th>
	                <td mat-cell style="width:30%;" 
	                    *matCellDef="let element">{{ element.subject }}
	                </td>
	            </ng-container>
	            <!-- Message category -->
	            <ng-container matColumnDef="category">
	                <th mat-header-cell *matHeaderCellDef 
	                    style="background-color: white; z-index:99999; width: 220px;">Category
	                </th>
	                <td mat-cell style="width:10%;" 
	                    *matCellDef="let element">{{ element.category }}
	                </td>
	            </ng-container>
	            <!-- Message activeStatus -->
	            <!-- 
	            <ng-container matColumnDef="activeStatus">
	                <th mat-header-cell *matHeaderCellDef 
	                    style="background-color: white; z-index:99999; width: 220px;">Status
	                </th>
	                <td mat-cell style="width:10%;" 
	                    *matCellDef="let element">{{ element.activeStatus }}
	                </td>
	            </ng-container>
	             -->
	            <!-- Active Status -->
                <ng-container matColumnDef="activeStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="background-color: white; z-index:99999">Status
                    </th>
                    <td mat-cell *matCellDef="let element" >

                        <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                     [disabled]="isEditing || !visibleModify"
                                     [useStatusOptions]="'status'"
                                     [selectedItem]="element.activeStatus"
                                     [controlWidth]="'120px'"
                                     (itemSelected)="element.activeStatus = $event; onStatusChange()">
                        </dw-dropdown>

                        <span *ngIf="selectedRecord?.id !== element.id"
                              style="padding-left: 3px;">{{element.activeStatus}}</span>
                    </td>
                </ng-container>
	
	            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	            <tr mat-row
	                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
	                [ngClass]="{'row-selected': tableRowIdx == Idx}"
	                (click)="onRowClicked(row)">
	            </tr>
	
	        </table>
	    </div>
	</div>
</div>

<p-dialog header="Message Detail" [focusOnShow]="false"
          [(visible)]="messageBodyDlg" [modal]="true"
          [style]="{width: '1100px', height: '675px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="false" >
    <app-message-detail #MessageBodyDetail
            [messageBody]="messageBody"
            (submitClicked)="doMessageDetailSubmit($event)"
            (cancelClicked)="messageBodyDlg=false">
    </app-message-detail>

</p-dialog>
